// extracted by mini-css-extract-plugin
export default {"tokens":"\"../../styles/tokens.css\"","coolGray":"#f4f4f4","divider":"styles_divider__q4bVV"};